import React, { useState } from 'react';
import { Form, Input, Button, Toast, SpinLoading } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api';
import './Login.css';

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (values: { employeeId: string; password: string }) => {
    setLoading(true);
    try {
      const result = await api.login(values.employeeId, values.password);

      if (result.success && result.data?.access_token) {
        // 登录成功
        const token = result.data.access_token;
        const user = {
          employeeId: result.data.userInfo.preferred_username,
          realname: result.data.userInfo.display_name
        };
        
        // 保存登录状态和用户信息
        login(token, user);
        
        // 显示成功消息
        Toast.show({
          icon: 'success',
          content: '登录成功',
        });
        
        // 跳转到首页
        navigate('/');
      } else {
        // 登录失败
        Toast.show({
          icon: 'fail',
          content: result.message || '登录失败，请检查账号和密码',
        });
      }
    } catch (error) {
      console.error('登录错误:', error);
      Toast.show({
        icon: 'fail',
        content: '网络错误，请稍后再试',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">市场调研系统</h2>
        <p className="login-subtitle">请登录您的账号</p>
        
        <Form
          layout="vertical"
          onFinish={handleLogin}
          footer={
            <Button 
              block 
              type="submit" 
              color="primary" 
              size="large"
              loading={loading}
              disabled={loading}
            >
              {loading ? <SpinLoading /> : '登录'}
            </Button>
          }
        >
          <Form.Item
            name="employeeId"
            label="员工工号"
            rules={[{ required: true, message: '请输入工号' }]}
          >
            <Input placeholder="请输入工号" />
          </Form.Item>
          
          <Form.Item
            name="password"
            label="密码"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input placeholder="请输入密码" type="password" />
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login; 